export const users = {
  appBarTitle: "المستخدمون",
  totalFleetOwners: "صاحب أسطول",
  totalSingleOwners: "سائق حر",
  totalTrips: "عدد الرحلات",
  totalKms: "كيلومترات مقطوعة",
  totalMaintenances: "مصاريف مسجلة",
  totalDeletedLogs: "سجلات المصاريف المحذوفة",
  totalDrivers: "سائق في أسطول",
  totalWhitelistedDrivers: "سائق مؤهل",
  totalStandardDrivers: "سائق غير مؤهل",
  singleOwner: "سائق حر",
  fleetOwner: "صاحب أسطول",
  driver: "سائق في أسطول",
  user: "المستخدم",
  totalCompletedProfiles: "حساب مكتمل",
  totalVehiclesAdded: "مركبة مضافة",
  segments: {
    uncategorizedBasic: "غير مصنّف",
    pvBasic: "PV كلاسيك",
    pvSilver: "PV فضي",
    pvGold: "PV ذهبي",
    pvPlatinum: "PV بلاتيني",
    cvBasic: "CV كلاسيك",
    cvSilver: "CV فضي",
    cvGold: "CV ذهبي",
    cvPlatinum: "CV بلاتيني",
  },
  table: {
    name: "الاسم",
    phoneNumber: "رقم الموبايل",
    numberOfVehicles: "المركبات",
    numberOfDrivers: "السائقين",
    numberOfTripsOwners: "عدد الرحلات",
    totalCoveredKms: "إجمالي الكيلومترات المقطوعة",
    numberOfMainetnances: "المصاريف",
    teamName: "اسم الفريق (اسم المالك)",
    joiningDate: "الانضمام",
    joiningDateTooltip: "تاريخ الانضمام",
    numberOfPendingInvitations: "الدعوات قيد الانتظار",
    numberOfPendingRequests: "الطلبات قيد الانتظار",
    numberOfTrips: "عدد الرحلات",
    driverStatus: "حالة السائق",
    level: "المستوى",
    totalPoints: "مجموع النقاط المجمعة",
    totalKms: "إجمالي الكيلومترات المقطوعة",
    totalMaintenances: "إجمالي المصاريف المسجلة",
    nationalId: "الرقم القومي",
    roleStatus: "حالة الدور",
    switchedFrom: "متغير من",
    roleStatusOptions: {
      primary: "اساسي",
      switched: "متغير",
    },
    nationalIdStatus: "حالة الرقم القومي",
    approved: "مقبول",
    pending: "قيد الانتظار",
    rejected: "مرفوض",
    notSubmitted: "غير مقدم",
    segment: "الشريحة",
    owner: "المالك",
    driver: "السائق",
    segmentLevel: "الشريحة / المستوى",
    activity: "النشاط",
    status: "الحالة",
    vehiclesShort: "مركبات",
    driversShort: "سائقين",
    tripsShort: "رحلات",
    kmsShort: "كم",
    expensesShort: "مصاريف",
    pointsShort: "نقاط",
    invitationsShort: "دعوات",
    requestsShort: "طلبات",
  },
  filters: {
    joiningDate: "تاريخ الانضمام",
    role: "الوظيفة",
    owner: "مالك",
    driver: "سائق",
    both: "كلاهما",
    numberOfVehicles: "عدد المركبات",
    numberOfTrips: "عدد الرحلات",
    driverStatus: "حالة السائق",
    numberOfDrivers: "عدد السائقين",
    numberOfMaintenaces: "عدد المصاريف",
    expenseType: "نوع المصروف",
    totalCoveredKms: "عدد الكيلومترات المقطوعة",
    level: "المستوى",
    collectedPoints: "النقاط المجمعة",
    teamStatus: "حالة الفريق",
    nationalId: "المستخدمين الذين يمتلكون رقم قومي",
    roleStatus: "حالة الدور",
    profileStatus: "حالة الحساب الشخصي",
    nationalIdVerificationStatus: "حالة التحقق من الرقم القومي",
    segment: "الشريحة",
    options: {
      vehicles: {
        zero: "صفر",
        moreThanOrEqual1: "أكبر من أو يساوي 1",
        moreThanOrEqual3: "أكبر من أو يساوي 3",
        moreThanOrEqual5: "أكبر من أو يساوي 5",
        moreThanOrEqual10: "أكبر من أو يساوي 10",
      },
      drivers: {
        zero: "صفر",
        moreThanOrEqual1: "أكبر من أو يساوي 1",
        moreThanOrEqual3: "أكبر من أو يساوي 3",
        moreThanOrEqual5: "أكبر من أو يساوي 5",
        moreThanOrEqual10: "أكبر من أو يساوي 10",
      },
      maintenances: {
        zero: "صفر",
        moreThanOrEqual1: "أكبر من أو يساوي 1",
        moreThanOrEqual3: "أكبر من أو يساوي 3",
        moreThanOrEqual5: "أكبر من أو يساوي 5",
        moreThanOrEqual10: "أكبر من أو يساوي 10",
      },
      trips: {
        zero: "صفر",
        moreThanOrEqual1: "أكبر من أو يساوي 1",
        moreThanOrEqual5: "أكبر من أو يساوي 5",
        moreThanOrEqual10: "أكبر من أو يساوي 10",
      },
      coveredKms: {
        zero: "صفر",
        moreThanOrEqual1: "أكبر من أو يساوي 1 كم",
        moreThanOrEqual10: "أكبر من أو يساوي 10 كم",
        moreThanOrEqual50: "أكبر من أو يساوي 50 كم",
        moreThanOrEqual100: "أكبر من أو يساوي 100 كم",
        moreThanOrEqual1000: "أكبر من أو يساوي 1000 كم",
      },
      points: {
        zero: "صفر",
        moreThanOrEqual50: "أكبر من أو يساوي 50",
        moreThanOrEqual100: "أكبر من أو يساوي 100",
        moreThanOrEqual1000: "أكبر من أو يساوي 1000",
        moreThanOrEqual2000: "أكبر من أو يساوي 2000",
        moreThanOrEqual4000: "أكبر من أو يساوي 4000",
        moreThanOrEqual5000: "أكبر من أو يساوي 5000",
        moreThanOrEqual15000: "أكبر من أو يساوي 15000",
      },
      teamStatus: {
        inTeam: "في الفريق",
        offTeam: "غادر الفريق",
      },
      nationalId: {
        yes: "نعم",
        no: "لا",
      },
      singleOwnerRoleStatus: {
        primary: "اساسي",
        switchedFromFleetOwner: "متغير من صاحب أسطول",
        switchedFromDriver: "متغير من سائق في أسطول",
      },
      fleetOwnerRoleStatus: {
        primary: "اساسي",
        switchedFromSingleOwner: "متغير من سائق حر",
        switchedFromDriver: "متغير من سائق في أسطول",
      },
      driverRoleStatus: {
        primary: "اساسي",
        switchedFromSingleOwner: "متغير من سائق حر",
        switchedFromFleetOwner: "متغير من صاحب أسطول",
      },
      profileStatus: {
        completed: "مكتمل",
        incomplete: "غير مكتمل",
      },
      nationalIdVerificationStatus: {
        notSubmitted: "غير مقدم",
        pending: "قيد الانتظار",
        approved: "مقبول",
        rejected: "مرفوض",
      },
    },
  },
  driversList: {
    whiteListedDrivers: 'السائقون المؤهلون',
    standardDrivers: 'السائقون الغير مؤهلين',
    driverStatus: 'حالة السائق',
    whitelisted: 'مؤهل',
    standard: 'غير مؤهل',
    editDriverStatus: 'تعديل حالة السائق',
    whiteListingConfirmMsg1: 'هل أنت متأكد أنك تريد إضافة ',
    whiteListingConfirmMsg2: ' إلى قائمة المؤهلين؟',
    standardConfirmMsg1: 'هل أنت متأكد أنك تريد إزالة ',
    standardConfirmMsg2: ' من قائمة المؤهلين؟',
    addToWhiteList: 'أضف إلى قائمة المؤهلين',
    removeFromWhitelist: 'أزل من قائمة المؤهلين',
    addToWhiteListMsg:
      'هل أنت متأكد أنك تريد إضافة السائقين المختارين إلى قائمة المؤهلين؟',
    removeFromWhitelistMsg:
      'هل أنت متأكد أنك تريد إزالة السائقين المختارين من قائمة المؤهلين؟',
    bulkQualifying: {
      modalTitle: 'إضافة سائقين إلى قائمة المؤهلين',
      phoneNumber: 'رقم الهاتف',
      uploadLabel: 'رفع ملف من الكمبيوتر',
      addSingleDriver: 'إضافة سائق واحد',
      addMultipleDrivers: 'إضافة سائقين متعددين',
      unqualifiedDrivers: 'سائقون لم يتم تأهيلهم',
      rejectedDriversMsg:
        'عذرا! تم تأهيل :successCount سائقين بنجاح, ولكن لم نتمكن من رفع :failCount سائقين. يمكنك تحميل الملف المرفق لمزيد من التفاصيل.',
      validations: {
        phoneRequired: 'رقم الهاتف مطلوب',
        invalidPhoneNumber: 'رقم الهاتف غير صحيح',
        fileRequired: 'ملف الاكسل مطلوب',
      },
      messages: {
        singlePhoneAdded: 'تم تأهيل السائق بنجاح',
        multiplePhoneAdded: 'تم تأهيل :count سائقين بنجاح',
      },
      excelFileLables: {
        number: 'Number',
        name: 'Driver Name',
        phone: 'Phone Number',
        reason: 'Comment',
      },
    },
  },
  pendingDrivers: {
    phoneNumber: 'رقم هاتف السائق',
    importDate: 'تاريخ الارفاق',
    TotalPendingDrivers: 'إجمالى السائقين المعلقين',
    table: {
      driverName: 'اسم السائق',
      phoneNumber: 'رقم هاتف السائق',
      ownerName: 'اسم المالك',
      importDate: 'تاريخ الارفاق',
      invitationsStatus: 'حالة الدعوة',
      driverStatus: 'حالة السائق',
    },
    filters: {
      importedDate: 'تاريخ الإرفاق',
      teamName: 'اسم الفريق',
      invitationStatus: 'حالة الدعوة',
      qualificationStatus: 'حالة التأهيل',
      options: {
        invitation: {
          invited: 'مدعو',
          notInvited: 'غير مدعو',
        },
        qualification: {
          qualified: 'مؤهل',
          notQualified: 'غير مؤهل',
        },
      },
    },
    qualified: "مؤهل",
    notQualified: "غير مؤهل",
    invited: "مدعو",
    notInvited: "غير مدعو",
    totalPendingDrivers: "سائق منتظر",
    totalQualifiedDrivers: "سائق مؤهل",
    totalUnqualifiedDrivers: "سائق غير مؤهل",
    editDriverStatus: "تعديل حالة السائق",
    qualifyConfirmMsg: "هل أنت متأكد أنك تريد تأهيل :driver ",
    disqualifyConfirmMsg: "هل أنت متأكد أنك تريد إلغاء تأهيل :driver ",
    driver: "هذا السائق",
  },
  userDetails: {
    userProfile: 'ملف المستخدم الشخصي',
    dateOfBirth: 'تاريخ الميلاد',
    job: 'الوظيفة',
    location: 'المكان',
    gender: 'النوع',
    phoneNumber: 'رقم الموبايل',
    email: 'الإيميل',
    joiningDate: 'تاريخ الانضمام',
    verificationDate: 'تاريخ التحقق',
    level: 'المستوى',
    blockConfirmation:
      'سيتم تسجيل خروج المستخدمين المحظورين ولن يتمكنوا من تسجيل الدخول بعد الآن حتى يتم إلغاء حظرهم',
    unblockConfirmation:
      "سيتمكن المستخدم من استخدام التطبيق مرة أخرى بشكل طبيعي",
    switchedFrom: "متغير من",
    primary: "اساسي",
    nationalIdVerificationStatus: "حالة التحقق من الرقم القومي",
    nationalIdVerificationStatusOptions: {
      notSubmitted: "غير مقدم",
      pending: "قيد الانتظار",
      approved: "مقبول",
      rejected: "مرفوض",
    },
    nationalIdDetails: "تفاصيل الرقم القومي",
    nidFullName: "الاسم الكامل",
    nidBirthDate: "تاريخ الميلاد",
    nidGender: "النوع",
    nidAddress: "العنوان",
    nidReligion: "الديانة",
    nidMaritalStatus: "الحالة الاجتماعية",
    nidProfession: "المهنة",
    roles:{
      singleOwner: "سائق حر",
      fleetOwner: "صاحب أسطول",
      driver: "سائق في أسطول",
    },
    fleetOwner: {
      totalTeamTrips: "إجمالي عدد رحلات الفريق",
      totalKmsCovered: "إجمالي عدد الكيلومترات المقطوعة في جميع الرحلات",
      totalMaintenances: "إجمالي عدد المصاريف المسجلة",
      totalExpenses: "المبلغ الإجمالي للنفقات",
      pendingInvitations: "الدعوات المعلقة",
      pendingRequests: "الطلبات المعلقة",
      teamDriversList: "قائمة سائقي الفريق",
      fleetOwner: "صاحب أسطول",
      table: {
        driverName: "اسم السائق",
        phoneNumber: "رقم الهاتف",
        status: "الحالة",
        totalPointsCollected: "إجمالي النقاط المجمعة",
        level: "المستوى",
        joiningDate: "تاريخ الانضمام للفريق",
        numberOfTrips: "عدد الرحلات",
        totalCoveredKms: "إجمالي عدد الكيلومترات المغطاة",
        maintenanceLogs: "المصاريف المسجلة",
        totalExpenses: "المصروفات الكلية",
        driverStatus: {
          inTeam: 'في الفريق',
          left: 'غادر الفريق',
        },
      },
    },
    singleOwner: {
      totalTeamTrips: "إجمالي عدد رحلات الفريق",
      totalKmsCovered: "إجمالي عدد الكيلومترات المغطاة على جميع الرحلات",
      totalMaintenances: "إجمالي عدد المصاريف المسجلة",
      totalExpenses: "المصروفات الكلية",
      pendingInvitations: "الدعوات المعلقة",
      pendingRequests: "الطلبات المعلقة",
      vehiclesList: "قائمة المركبات",
      singleOwner: "سائق حر",
      totalVehiclesAdded: "إجمالي عدد المركبات المضافة",
      table: {
        vehicleName: "اسم المركبة",
        vehicleBrand: "الماركة المركبة",
        vehicleType: "نوع المركبة",
        odometerReading: "قراءة العداد",
      },
    },
    driver: {
      totalKmsCovered: "إجمالي الكيلومترات المغطاة لجميع الرحلات المنتهية",
      totalMaintenances: "إجمالي سجلات المصاريف المضافة",
      totalExpenses: "المصروفات الكلية",
      totalPoints: "مجموع النقاط التي تم جمعها",
      totalRewards: "إجمالي المكافآت المكتسبة أو المستردة",
      pointsDetails: "تفاصيل النقاط",
      rewardsDetails: "تفاصيل المكافآت",
      requestsDetails: "تفاصيل الطلبات",
      driver: "سائق في أسطول",
      table: {
        points: 'النقاط',
        pointsType: 'النوع',
        collectionDate: 'تاريخ الجمع',
        requiredPoints: 'النقاط المطلوبة',
        status: 'الحالة',
        rewardsType: 'النوع',
        amount: 'الكمية',
        earningDate: 'تاريخ الكسب',
        level: 'المستوى',
        requestNumber: 'رقم الطلب',
        requestDate: 'تاريخ الطلب',
        attachments: 'المرفقات',
        decisionDate: 'تاريخ القرار',
        actions: 'الإجراءات',
        viewAttachments: 'عرض المرفقات',
        approve: 'موافقة',
        reject: 'رفض',
        driverLicense: 'رخصة السائق',
        personalPhoto: 'الصورة الشخصية',
        attachmentsNoLongerAvailable: 'المرفقات لم تعد متاحة',
        pointsTypes: {
          completeProfile: "استكمال الملف الشخصي",
          watchTutorial: "مشاهدة البرنامج التعليمي",
          completeTrip: "استكمال الرحلة",
          addMaintenance: "إضافة مصروف",
          joinTeam: "انضمام إلى فريق",
        },
        rewardStatus: {
          earned: 'مكتسبه',
          redeemed: 'مفعله',
          expired: 'منتهية الصلاحية',
        },
        rewardType: {
          voucher: 'قسيمة',
          rechargeCard: 'كارت شحن',
          discount: 'خصم',
        },
        verificationRequest: {
          approveRequest: "قبول الطلب",
          approvedRequestMsg:
            "رقم الرخصة المدخل صحيح وسيتم حفظه في تفاصيل السائق. هل أنت متأكد أنك تريد قبول هذا الطلب؟ ",
          rejectRequest: "رفض الطلب",
          rejectRequestMsg: "من فضلك اختر سبب لرفض هذا الطلب",
          saveLicenseData: "الموافقة علي رخصة السائق",
          enterLicenseNumber: "أدخل رقم الرخصة",
          rejectionReason: "سبب الرفض",
          selectRejectionReason: "اختر سبب الرفض",
          viewRejectionReason: "عرض سبب الرفض",
          validations: {
            licenseRequired: "رقم الرخصة مطلوب",
            licenseLength: "يجب أن يتكون رقم الرخصة من 14 رقمًا",
            licenseValid:
              "يجب أن يتكون رقم الرخصة من أرقامًا فقط ولا يُسمح بالأحرف أو الرموز الخاصة",
            licenseCurrentlyExist:
              "رقم الرخصة المدخل مرتبط بالفعل بسائق مسجل، .",
            cannotBeReused: "ولا يمكن إعادة استخدامه",
            licensePreviouslyExist1: "رقم الرخصة المدخل ",
            matchesDeletedDriver: "يتطابق مع سائق محذوف.",
            licensePreviouslyExist2: "هل أنت متأكد من رغبتك في المتابعة؟",
            rejectionReasonRequired: "سبب الرفض مطلوب",
            invalidNationalId: "الرقم القومي غير صحيح.",
          },
        },
      },
      standard: 'غير مؤهل',
      whiteListed: 'مؤهل',
      editDriverStatus: 'تعديل حالة السائق',
      whiteListingConfirmMsg1: 'هل أنت متأكد أنك تريد إضافة ',
      whiteListingConfirmMsg2: ' إلى قائمة المؤهلين؟',
      standardConfirmMsg1: 'هل أنت متأكد أنك تريد إزالة ',
      standardConfirmMsg2: ' من قائمة المؤهلين؟',
    },
    referralDetails: {
      referralRewards: "جوائز الإحالات",
      inviteeName: "اسم المدعو",
      inviteeRole: "دور المدعو",
      phoneNumber: "رقم الهاتف",
      inviteeStatus: "حالة المدعو",
      invitationDate: "تاريخ الدعوة",
      rewardStatus: "حالة الجائزة",
      rewardAmount: "قيمة الجائزة",
      redemptionDate: "تاريخ الاسترداد",
      roles: {
        singleOwner: "سائق حر",
        fleetOwner: "صاحب أسطول",
        driver: "سائق في أسطول",
      },
    },
  },
};
